import React from "react";
                  
export function CustomerRegister() {
    return <h1>Hello!</h1>
}